import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import MatLogPackageUpsert from './components/MatLogPackageUpsert';

const MatLogPackageEdit: React.FC = () => {
  const { id } = useParams();
  const location = useLocation();
  const idsFromQuery = React.useMemo(() => {
    try {
      const qs = new URLSearchParams(location.search || '');
      const raw = String(qs.get('ids') || '').trim();
      if (!raw) return [];
      return raw
        .split(',')
        .map((x) => decodeURIComponent(String(x || '').trim()))
        .filter((x) => x);
    } catch {
      return [];
    }
  }, [location.search]);
  const effectiveIds = idsFromQuery.length ? idsFromQuery : id ? [String(id)] : [];
  return (
    <MatLogPackageUpsert mode="edit" editIds={effectiveIds} />
  );
};

export default MatLogPackageEdit;
